<template>
  <div :class="[$style.wrapper, active && $style.active]">
    <div class="d-flex fill-height">
      <div :class="$style.label">
        №{{ id }}
      </div>
      <div class="d-flex flex-column justify-center" :class="$style.body">
        <v-list-item three-line class="mx-auto">
          <v-list-item-content class="mx-auto px-0">
            <v-list-item-subtitle class="text--black">
              {{ address }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="lastMessage">
              {{ lastMessage }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <div ></div>
      </div>
      <v-badge v-if="unread" color="red" :content="unread" :class="$style.unread" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogPreview',
  props: {
    id: [String, Number],
    lastMessage: String,
    address: String,
    unread: [String, Number],
    active: Boolean,
  },
}
</script>
<style module lang="scss" src="./style.scss"></style>
